// @flow
import glamorous from 'glamorous'
import { space, margin, padding, breakpoint, spacing } from 'style'

const Wrapper = glamorous.div(
  {
    ...margin.x('auto'),
    maxWidth: '75rem',
    // $FlowFixMe
    paddingLeft: [`${spacing(3)}`, 'env(safe-area-inset-left)'],
    // $FlowFixMe
    paddingRight: [`${spacing(3)}`, 'env(safe-area-inset-right)'],
    ...breakpoint.small({
      ...padding.x(2),
    }),
  },
  space,
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/components/Wrapper.js